export const APP_VERSION = "v3.2.03";
export const SHOPID = "2cccc13f-4a64-42e1-91a4-d4699c430842";
export const S3_URL = "https://lailaocf-bucket.s3.amazonaws.com/files/";
export const USER_KEY = "@userKey";
export const USER_KEY2 = "USER_DATA";
export const SHOP_DATA = "SHOP_DATA";
export const FONT_HEADER_SIZE = 16;
export const BUTTON_INDEX = 100;
export const PRIMARY_FONT_BLACK = { fontColor: "black", fontWeight: "bold" };
export const CANCEL_STATUS = "CANCELED";
export const DOING_STATUS = "DOING";
export const WAITING_STATUS = "WAITING";
export const SERVE_STATUS = "SERVED";
export const CART_STATUS = "CART";
export const ACTIVE_STATUS = "ACTIVE";
export const CALLTOCHECKOUT_STATUS = "CALLTOCHECKOUT";
export const NOT_STATUS = "NOT";
export const CHECKOUT_STATUS = "CHECKOUT";
/**
 * THE 4B BRAND GRADIENT.
 *
 * The logo (src/image/logo_main.png) sweeps pink-red at the top-left to purple at the
 * bottom-right. Sampled from it: the reddest pixel is #F1132C, the purple end settles on
 * #5B3290, and the body of the mark sits around #D01840 / #B81850.
 *
 * #DB1237 and #5D0072 were ALREADY in this file as COLOR_TOMATO and BG_GRADIENT_NEW —
 * the brand palette was defined and then never wired to the thing that paints the app.
 * COLOR_APP stayed on an unrelated blue (rgba(26,102,190)) which is why the product did
 * not look like the logo on its own marketing.
 *
 * 135deg so the sweep runs top-left to bottom-right exactly as the logo does, with red
 * leading — the colour people recognise 4B by.
 *
 * Used in 130 files, so this single value is the whole app's identity. Change it here,
 * never inline.
 */
export const BRAND_RED = "#DB1237";
export const BRAND_PURPLE = "#5D0072";
export const COLOR_APP = `linear-gradient(135deg, ${BRAND_RED} 0%, #8E1759 55%, ${BRAND_PURPLE} 100%)`;
export const COLOR_WHITE = "#FFF";
export const COLOR_GRAY = "#f2f2f2";
//* Was #5a54a2, a blue-leaning purple from the old palette. Now the logo's purple.
export const COLOR_TEXT = "#5D0072";
export const COLOR_APP_CANCEL = "red";
export const COLOR_BORDER_IMAGE_B0X = "#BDBDBD";
export const LINEAR_GRADIENT_BG =
  "linear-gradient(180deg, #3C169B 0%, #592375 0.01%, #2C206C 100%)";
export const BG_GRADIENT_NEW =
  "linear-gradient(45deg, #5D0072 0%, #DB1237 100%)";
export const COLOR_TOMATO = "#DB1237";

//Lives status
export const COMPLETED = "COMPLETED";
export const CREATED = "CREATED";
export const CANCELLED = "CANCELLED";
export const READYTOSHIP = "READYTOSHIP";
export const SHIPPING = "SHIPPING";
export const SHIPPING_COMPLETED = "SHIPPING_COMPLETED";
export const ONAIR = "ONAIR";
export const PROCESSING = "PROCESSING";
export const WARNING = "WARNING";
export const ORDERINSALEPAGE = "ORDERINSALEPAGE";
export const COMMISSION_OFFICE = 2;
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const SHOW_NOTICE_EXPIRED = "SHOW_NOTICE_EXPIRED";
export const IMAGE_4B = "3f84530a-27a1-4591-90f3-72bfcc3d678a.png";
export const SHOP_ID_FOR_TEST = "63ec6d38c617221e6ccf5edc";

// logicstices keys
export const HAL_KEY = "HAL";
export const MIXAY_KEY = "MIXAY";
export const JNT_KEY = "JNT";
export const ANOUSIT_KEY = "ANOUSITH";

//-------------------- url app js ------------------------------------------------------------------------------->

// Local
//export const SERVER_URI = "http://localhost:7070/";
//export const SOCKET_SERVER_URI = "ws://localhost:7070";

// Production
//* Overridable for local development so pointing the app at a local API does not require
//* editing (and risking committing) this file. Unset in every real build, so production
//* and every deployed environment behave exactly as before.
export const SERVER_URI =
  process.env.REACT_APP_SERVER_URI || "https://api.bbbb.com.la/";
export const SOCKET_SERVER_URI =
  process.env.REACT_APP_SOCKET_URI || "wss://api.bbbb.com.la/";

// Kube
//export const SERVER_URI = "https://cf-kube-api.lailaolab.com/";
//export const SOCKET_SERVER_URI = "wss://cf-kube-api.lailaolab.com/";

// // Dev
// export const SERVER_URI = "https://api-dev.bbbb.com.la/";
// export const SOCKET_SERVER_URI = "wss://api-dev.bbbb.com.la/";

//!-------- URI link sale page ----->
export const LINK_SALE_PAGE = "https://sp.bbbb.com.la"; // prod
export const LINK_SHOP_PAGE = "https://shop.bbbb.com.la/"; // prod

// -------- feacbook app id ------->
// export const APP_ID = "379716970101549"; // dev
// export const APP_ID = "908690234350513"; // dev new
// export const APP_ID = "573069010563277";    // dev — ตรงกับ cf-api บน EC2
export const APP_ID = "694959341044795"; // production

// ------ link package ----->
export const WEB_LANDING_PAGE_URL = "https://www.bbbb.com.la";

// link package pricing -------------------------------------
export const CONTACT_4B_TEAM =
  "https://api.whatsapp.com://send?phone=02029933969";

// empty image ===========================
export const EMPTY_IMAGE =
  "https://www.generationsforpeace.org/wp-content/uploads/2018/03/empty.jpg";
export const WARNING_IMAGE =
  "https://icones.pro/wp-content/uploads/2021/05/symbole-d-avertissement-violet.png";

// facebook base url
export const FACEBOOK_API_VERSION = "v19.0";
export const FACEBOOK_BASE_URL = `https://graph.facebook.com/${FACEBOOK_API_VERSION}/`;

// image slip
export const IMAGE_ENDPOINT = "https://payment-gateway.lailaolab.com/v1/api/";

export const DEFAULT_REPLY_MESSAGE = `🙏ສະບາຍດີ {{cfName}} ລູກຄ້າ CF ໄດ້ລາຍການ
📦ລະຫັດ & ຊື່ສິນຄ້າ : {{cfMessage}} {{productName}} (x{{amountCf}}) 
💰ລາຄາ: {{price}} {{currency}}
💰ລາຄາລວມ: {{totalPrice}} {{currency}}
⏰ວັນທີ່ : {{datetime}}
👉ອໍເດີ້ທັງຫມົດ : {{orderCount}} ລາຍການ
👉ລວມເງິນທັງຫມົດ(ກີບ) : {{summaryPrice}} 
👉ລວມເງິນທັງຫມົດ(ບາດ) : {{summaryPriceBaht}} 
👉ລວມເງິນທັງຫມົດ(ໂດລາ) : {{summaryPriceUsd}} 

------------------------------
🌈ລາຍການສັ່ງຊື້ຂອງລູກຄ້າສາມາດເບິ່ງໄດ້ໃນປຸ່ມ 
👇ເບິ່ງລາຍການສິນຄ້າ👇
ເບິ່ງລາຍການ CF ແລ້ວຊຳລະເງິນ ໃຫ້ທາງຮ້ານເລີຍເດີ້ 
🙏ຂໍຂອບໃຈ`;
// export const DEFAULT_REPLY_MESSAGE = 'ສະບາຍດີ {{cfName}}, ຍິນດີລູກຄ້າທີ່ໄດ້ Cf ຖືກສິນຄ້ານີ້ແລ້ວເດີ\nລະຫັດ: {{cfMessage}}\nຊື່ສິນຄ້າ: {{productName}}\nລາຄາ: {{price}} ກີບ\nວັນທີ່: {{datetime}}\n\n-----------------------\nລູກຄ້າໄດ້ຄອມເມັ້ນ Cf ລະຫັດ ["{{cfMessage}}"]\nຖ້າຈົບໄລຟ ແລ້ວລະບົບຈະແຈ້ງຍອດໃຫ້ລູກຄ້າເດີ້'
export const DEFAULT_REPLY_POST_MESSAGE = `
🙏ສະບາຍດີ {{cfName}} ລູກຄ້າ CF ໄດ້ລາຍການ
📦ລະຫັດ & ຊື່ສິນຄ້າ : {{cfMessage}} {{productName}} (x{{amountCf}}) 
💰ລາຄາ: {{price}} {{currency}}
💰ລາຄາລວມ: {{totalPrice}} {{currency}}
⏰ວັນທີ່ : {{datetime}}
👉ອໍເດີ້ທັງຫມົດ : {{orderCount}} ລາຍການ
👉ລວມເງິນທັງຫມົດ(ກີບ) : {{summaryPrice}} 
👉ລວມເງິນທັງຫມົດ(ບາດ) : {{summaryPriceBaht}} 
👉ລວມເງິນທັງຫມົດ(ໂດລາ) : {{summaryPriceUsd}} 

------------------------------
🌈ລາຍການສັ່ງຊື້ຂອງລູກຄ້າສາມາດເບິ່ງໄດ້ໃນປຸ່ມ 
👇ເບິ່ງລາຍການສິນຄ້າ👇
ເບິ່ງລາຍການ CF ແລ້ວຊຳລະເງິນ ໃຫ້ທາງຮ້ານເລີຍເດີ້ 
🙏ຂໍຂອບໃຈ`;

export const DEFAULT_SUMMARY_MESSAGE = `ສະບາຍດີລູກຄ້າ 
ລາຍການທີ່ລູກຄ້າ CF ໄດ້ຍອດ
{{cfText}}
ລວມຍອດທັງໝົດ : {{total}} ກີບ

ໍຂໍຂອບໃຈທີ່ໃຊ້ບໍລິການ
`;
export const DEFAULT_SUMMARY_POST_MESSAGE = `ສະບາຍດີລູກຄ້າ 
ລາຍການທີ່ລູກຄ້າ CF ໄດ້ຍອດ
{{cfText}}
ລວມຍອດທັງໝົດ : {{total}} ກີບ

ໍຂໍຂອບໃຈທີ່ໃຊ້ບໍລິການ
`;

export const DEFAULT_MS_CLAIM_BALANCE = `🙏ສະບາຍດີ {{cfName}} 
⏰ວັນທີ່: {{datetime}}
ລູກຄ້າ CF ສິນຄ້າສຳເລັດແລ້ວ ກະລຸນາຊຳລະເງິນໃຫ້ທາງຮ້ານແນ່ເດີ້ເຈົ້າ🥰

👇ຊຳລະເງິນໄດ້ທີ່👇`;

export const LOGISTICS = [
  { id: 0, name: "ຮຸ່ງອາລຸນ ຂົນສົ່ງດ່ວນ", icon: "/images/hal-icon.png" },
];

export const LOGISTICS_DATAS = {
  hal: {
    name: "ຮຸ່ງອາລຸນ",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqApAoxPZ2kMZ2WyGcxY_8fR9Klsqm_hAN8Q&s",
    keyDefault: "HAL",
  },
  mixay: {
    name: "ມີໄຊ",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwsP1N9sEQz_EASyy90rDvyE1uUKOW6u3sUA&s",
    keyDefault: "MIXAY",
  },
  jnt: {
    name: "J&T Express",
    image: "/images/jnt.png",
    keyDefault: "JNT",
  },
  anusith: {
    name: "ອານຸສິດ",
    image: "https://anousith-express.co/images/site_login_box.jpg",
    keyDefault: "ANUSITH",
  },
};

// export const TEXT_SERVICES = ["GOOGLE_CLOUD", "AMAZON_POLLY", "MICROSOFT_AZURE"];
export const TEXT_SERVICES = ["GOOGLE_CLOUD"];
export const K_LOCAL_STORAGE_PAGE_HISTORY = "LC_PAGE_HISTORY";
export const K_LOCAL_STORAGE_SHOP_DATA = "SHOP_DATA";
export const K_LOCAL_STORAGE_SHOP_SETTING_DATA = "SHOP_SETTING_DATA";
export const K_LOCAL_STORAGE_PAGE_FEED = (pageId) => `PAGE_FEED_${pageId}`;

export const RemoveFields = (arr, fields) => {
  if (Array.isArray(arr)) {
    return arr.map((item) => RemoveFields(item, fields));
  } else if (arr !== null && typeof arr === "object") {
    return Object.fromEntries(
      Object.entries(arr)
        .filter(([key]) => !fields.includes(key))
        .map(([key, value]) => [key, RemoveFields(value, fields)]),
    );
    // const _newObj = { ...arr };
    // fields.forEach((field) => {
    //   delete _newObj[field];
    // });
    // return _newObj;
  }
  return arr;
};
